//  Copyright (c) 2019-2023 Cigent Technology Inc. All Rights Reserved.
import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import { MatTooltip } from '@angular/material/tooltip';

export interface IPasswordAlertDialogConfig {
  title: string;
  text: string;
}

export interface IPasswordAlertDialogResult {
  password: string;
}

@Component({
    selector: 'app-password-alert-dialog-component',
    templateUrl: './password-alert-dialog-component.component.html',
    styleUrls: ['./password-alert-dialog-component.component.scss'],
    standalone: false
})
export class PasswordAlertDialogComponentComponent implements OnInit {
  @ViewChild('tooltip') tooltip: MatTooltip;
  form: UntypedFormGroup;
  capsOn: boolean = false;
  passwordInputIsFocused = false;

  constructor(private readonly dialogRef: MatDialogRef<PasswordAlertDialogComponentComponent, IPasswordAlertDialogResult>,
              private formBuilder: UntypedFormBuilder,
              @Inject(MAT_DIALOG_DATA) public dialogConfig: IPasswordAlertDialogConfig,
  ) {
    this.form = formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(10)]]
    });
  }

  ngOnInit(): void {
  }

  onClickOK(): void {
    const result: IPasswordAlertDialogResult = {
      password: this.form.value.password
    };
    this.dialogRef.close(result);
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  onCapsLockChanged(event: boolean) {
    this.capsOn = event && this.passwordInputIsFocused;
  }

  passwordFocus() {
    this.passwordInputIsFocused = true;
  }

  passwordBlur() {
    this.passwordInputIsFocused = false;
  }

}
